// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"dropdown-menu-item__visuallyhidden--jj0qu","focusable":"dropdown-menu-item__focusable--vTS0R","disabled":"dropdown-menu-item__disabled--VLXfN"};